/* Layouts */
// import { AuthLayout } from 'components/layouts/AuthLayout';
// import { MainLayout } from 'components/layouts/MainLayout';

import { AuthLayout } from 'components/layouts/AuthLayout';
import { MainLayout } from 'components/layouts/MainLayout';
import { Login } from 'pages/auth/Login';
import { OTPPage } from 'pages/auth/OTPPage';
import { Signup } from 'pages/auth/Signup';
import { Dashboard } from 'pages/Dashboard';
import { Profile } from 'pages/Profile';
import { Videos } from 'pages/Videos';
import { VideoUpdate } from 'pages/VideoUpdate';
import { VideoUpload } from 'pages/VideoUpload';

interface Route {
  path: string;
  component?: any;
  layout?: any;
  redirectTo?: string;
  isSecured?: boolean;
  isAuthScreen?: boolean;
}

export const routes: Route[] = [
  {
    path: '/auth',
    redirectTo: '/auth/login',
  },
  // {
  //   path: '/auth/login',
  //   component: Login,
  //   layout: AuthLayout,
  //   isAuthScreen: true,
  // },
  {
    path: '/auth/login',
    component: Login,
    layout: AuthLayout,
  },
  {
    path: '/auth/sign-up',
    component: Signup,
    layout: AuthLayout,
  },
  {
    path: '/auth/verify-otp',
    component: OTPPage,
    layout: AuthLayout,
  },
  {
    path: '/',
    component: Dashboard,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/videos',
    component: Videos,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/videos/upload',
    component: VideoUpload,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/videos/:id',
    component: VideoUpdate,
    layout: MainLayout,
    isSecured: true,
  },
  {
    path: '/profile',
    component: Profile,
    layout: MainLayout,
    isSecured: true,
  },
];

export default routes;
